import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { AdminLogisticPartnerService, LogisticPartnerListItem } from '../../../_services/admin-logistic-partner.service';

@Component({
    selector: 'app-logistic-partners-list',
    templateUrl: './logistic-partners-list.component.html',
    styleUrls: ['./logistic-partners-list.component.css'],
    standalone: false
})
export class LogisticPartnersListComponent implements OnInit, OnDestroy {
    partners: LogisticPartnerListItem[] = [];
    filteredPartners: LogisticPartnerListItem[] = [];
    loading = false;
    config: any;
    page = 1;
    itemPerPage = 10;

    // Filter
    statusFilter: 'ALL' | 'PENDING' | 'COMPLETED' | 'VERIFIED' | 'REJECTED' = 'ALL';

    constructor(
        private adminLogisticPartnerService: AdminLogisticPartnerService,
        private router: Router,
        private titleService: Title
    ) {
        this.titleService.setTitle('Logistic Partners');
    }

    ngOnInit(): void {
        this.loadPartners();
    }

    ngOnDestroy(): void {
        this.titleService.setTitle('');
    }

    loadPartners(): void {
        this.loading = true;
        this.adminLogisticPartnerService.listPartners().subscribe({
            next: (response) => {
                this.partners = response.data.data;
                this.applyFilter();
                this.loading = false;
            },
            error: () => {
                this.loading = false;
            }
        });
    }

    applyFilter(): void {
        if (this.statusFilter === 'ALL') {
            this.filteredPartners = this.partners;
        } else {
            this.filteredPartners = this.partners.filter(partner => partner.status === this.statusFilter);
        }
        this.setupPagination();
    }

    onStatusFilterChange(status: 'ALL' | 'PENDING' | 'COMPLETED' | 'VERIFIED' | 'REJECTED'): void {
        this.statusFilter = status;
        this.page = 1;
        this.applyFilter();
    }

    setupPagination(): void {
        this.config = {
            currentPage: this.page,
            itemsPerPage: this.itemPerPage,
            totalItems: this.filteredPartners.length,
            id: 'logistic-partners-listing'
        };
    }

    pageChange(page: number): void {
        this.page = page;
        this.setupPagination();
    }

    viewPartnerDetails(partner: LogisticPartnerListItem): void {
        this.router.navigate(['/admin', 'logistic-partners', partner.id]);
    }

    getDisplayName(partner: LogisticPartnerListItem): string {
        if (partner.carrierType === 'company') {
            return partner.companyName || 'Unknown Company';
        } else {
            return `${partner.firstName || ''} ${partner.lastName || ''}`.trim() || 'Unknown Agent';
        }
    }

    getPaymentMethod(partner: LogisticPartnerListItem): string {
        if (!partner.paymentInfo) {
            return 'N/A';
        }
        if (partner.paymentInfo.paymentType === 'MOBILE_MONEY') {
            return partner.paymentInfo.mobileMoneyProvider || 'Mobile Money';
        } else if (partner.paymentInfo.paymentType === 'BANK') {
            return partner.paymentInfo.bankName || 'Bank Transfer';
        }
        return 'N/A';
    }

    getStatusClass(status: string): string {
        switch (status) {
            case 'PENDING':
                return 'badge bg-warning';
            case 'COMPLETED':
                return 'badge bg-info';
            case 'VERIFIED':
                return 'badge bg-success';
            case 'REJECTED':
                return 'badge bg-danger';
            default:
                return 'badge bg-secondary';
        }
    }
}
